import React from 'react';
import PropTypes from "prop-types"
import BuilderCanvas from "../BuilderCanvas2";
import classNames from "classnames";

export default class BuilderSidePreview extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      isShowSidePreview: false,
    }
  }

  checkScrollPosition = () => {
    const isShowSidePreview = window.scrollY >= 400;
    if (isShowSidePreview !== this.state.isShowSidePreview) {
      this.setState({ isShowSidePreview })
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.checkScrollPosition);
  }

  async componentWillUnmount() {
    document.removeEventListener('scroll', this.checkScrollPosition)
  }

  handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); //smooth not work in safari
  }

  render() {
    const { type } = this.props;
    return  (
        <div className={classNames(
            'b-builder__side-preview',
            this.state.isShowSidePreview && ' b-builder__side-preview-visible',
            `b-builder__side-preview_${type}`
          )}
          onClick={this.handleScrollToTop}
        >
        <BuilderCanvas type='xsmall' fontSelectorSize='small' />
      </div>
    )
  }
}

BuilderSidePreview.proptypes = {
  type: PropTypes.oneOf(['fabric', 'detail'])
}
